import { render, staticRenderFns } from "./GenieKioskResidentContacts.vue?vue&type=template&id=2c99696a&"
import script from "./GenieKioskResidentContacts.vue?vue&type=script&lang=js&"
export * from "./GenieKioskResidentContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports